import { CheckIcon } from 'lucide-react'

export const OAuthSuccess = () => (
  <>
    <div className="mt-auto w-min rounded-full border-2 border-green-500 bg-green-50 p-6">
      <CheckIcon className="h-16 w-16 text-green-600" />
    </div>
    <span className="mt-6 text-lg text-neutral-900">Authentication successful!</span>
  </>
)
